import React, { lazy, Suspense } from 'react'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import SignInCallBack from '../authentication/SignInCallback'
import CorporateRiskScorePackage from '../companyAnalysis/score/corporateRiskScore/CorporateRiskScorePackage'
import { errorTypes } from '../errors/ErrorCustom'
import { ErrorPage } from '../layout/ErrorPage'
import { COMPONENTS, SIGN_IN_CALLBACK_ROUTE } from './constants'

const Layout = lazy(() => import('../layout'))
const LayoutForError = lazy(() => import('../layout/LayoutForError'))
const ErrorCustom = lazy(() => import('../errors/ErrorCustom'))

const renderComponent = (component) => {
  if (!component.name) {
    return null
  }

  return (
    <Route
      exact
      path={component.route}
      element={<Layout component={component} />}
    />
  )
}

const renderComponents = (components) => {
  if (!components) {
    return null
  }

  return Object.keys(components).map((key) => {
    return (
      <React.Fragment key={key}>
        {renderComponent(components[key])}
        {components[key].components &&
          renderComponents(components[key].components)}
      </React.Fragment>
    )
  })
}

export const Routers = ({ children }) => {
  return (
    <Suspense fallback={null}>
      <BrowserRouter>
        <Routes>
          <Route
            exact
            path="/corporateRiskScore"
            element={<CorporateRiskScorePackage />}
          />
          {renderComponents(COMPONENTS)}
          <Route
            exact
            path={'/'}
            element={
              <Navigate to={COMPONENTS.dashboard.components.dashboard.route} />
            }
          />
          <Route
            exact
            path={SIGN_IN_CALLBACK_ROUTE}
            element={<SignInCallBack />}
          />
          <Route
            path="/error"
            element={
              <ErrorPage>
                <LayoutForError>
                  <ErrorCustom errorType={errorTypes.INTERNAL_SERVER} />
                </LayoutForError>
              </ErrorPage>
            }
          />
          <Route
            path="*"
            element={
              <ErrorPage>
                <LayoutForError>
                  <ErrorCustom errorType={errorTypes.NOT_FOUND} />
                </LayoutForError>
              </ErrorPage>
            }
          />
          <Route
            path="/error-454"
            element={<ErrorCustom errorType={errorTypes.ERROR_454} />}
          />
        </Routes>
        {children}
      </BrowserRouter>
    </Suspense>
  )
}
